const labelStyle = {
  display: 'block',
  fontSize: 11,
  fontWeight: 700,
  color: '#64748B',
  textTransform: 'uppercase',
  letterSpacing: '.05em',
  marginBottom: 5,
};
const inputStyle = {
  width: '100%',
  padding: '9px 12px',
  border: '1.5px solid #E2E8F0',
  borderRadius: 8,
  fontSize: 13,
  background: '#fff',
  color: '#0F172A',
};

export function Fld({ label, type = 'text', value, onChange, note, required, ph, min, max, step, testId }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={labelStyle}>
        {label}
        {required && <span style={{ color: '#E63946' }}> *</span>}
      </label>
      <input
        data-testid={testId}
        type={type}
        value={value ?? ''}
        onChange={onChange}
        placeholder={ph || ''}
        min={min}
        max={max}
        step={step}
        style={inputStyle}
      />
      {note && <p style={{ fontSize: 11, color: '#94A3B8', marginTop: 4 }}>{note}</p>}
    </div>
  );
}

export function Sel({ label, value, onChange, opts, required, testId }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={labelStyle}>
        {label}
        {required && <span style={{ color: '#E63946' }}> *</span>}
      </label>
      <select data-testid={testId} value={value ?? ''} onChange={onChange} style={inputStyle}>
        {opts.map((o) => (
          <option key={o.v ?? o} value={o.v ?? o}>
            {o.l ?? o}
          </option>
        ))}
      </select>
    </div>
  );
}

export function TextA({ label, value, onChange, rows = 3, testId }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={labelStyle}>{label}</label>
      <textarea
        data-testid={testId}
        value={value ?? ''}
        onChange={onChange}
        rows={rows}
        style={{ ...inputStyle, resize: 'vertical' }}
      />
    </div>
  );
}
